import {
  GET_OFFERS_LIST_REQUEST,
  GET_OFFERS_LIST_SUCCESS,
  GET_OFFERS_LIST_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  offerList: {},
  loading: false,
  error: null,
};

export const OfferListReducer = (state = initialState, action) => {

  switch (action.type) {
    case GET_OFFERS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_OFFERS_LIST_SUCCESS:
      return {
        ...state,
        offerList: action.payload,
        loading: false,
        error: null,
      };

    case GET_OFFERS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
